// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const RowEnlargeIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={10} viewBox="0 0 28 10" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="row-enlarge" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><g id="Group" transform="translate(-.955)"><path id="bg" fill="#FFF" d="M8.955 1h12v8h-12z" /><path id="Combined-Shape" fill="currentColor" d="M21.955 0v10h-14V0zm-2 2h-10v6h10zm4 7V1l5 4zm-18 0V1l-5 4z" /></g></g></svg>
))
